import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bf9d144"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ads-items__section"
}
const _hoisted_2 = { class: "ads-items__inputs" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "ads-items__section" }
const _hoisted_6 = { class: "ads-items__container" }
const _hoisted_7 = { class: "ads-items__container-info" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "Адрес:", -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "Системный чат с:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "Id:", -1))
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "Чат с администрацией", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "Цена:", -1))
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "id:", -1))
const _hoisted_21 = { class: "ads-items__message-date" }
const _hoisted_22 = { class: "ads-items__container-top-right" }
const _hoisted_23 = { class: "items-in-column align-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "ellipsis" }, "...", -1))
const _hoisted_25 = { class: "items-in-column gap--0" }
const _hoisted_26 = ["disabled", "onClick"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 1,
  class: "ads-items__container-circle"
}
const _hoisted_29 = {
  key: 0,
  class: "center mt--30"
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  key: 1,
  class: "mb--0 ads-items__send-message ads-items__item"
}
const _hoisted_32 = ["disabled", "onClick"]
const _hoisted_33 = {
  key: 3,
  class: "mt--20 pt--20 pb--20"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center allBlockWidth" }, "Сообщений нет", -1))
const _hoisted_35 = [
  _hoisted_34
]

import { computed, onMounted, onUnmounted, ref, Ref, watch } from 'vue';
import { ChatComponent } from '@/components';
import { messagesFromChanelTypeFromBack } from '@/api/chat/types';
import { FormDataType } from '@/types';
import { useChatStore } from '@/store/modules/chat';
import { useUserStore } from '@/store/modules/user';
import { useRoute, useRouter } from 'vue-router';
import { useAppStore } from '@/store/modules/app';

type OptionType = {
  id: number;
  name: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'AllChats',
  props: /*#__PURE__*/_mergeModels({
    isShowAllMessagesLoading: { type: Boolean },
    sendMessageChatsLoading: {},
    allMessages: {},
    loadingChatIds: {},
    chatInfo: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels([
  'showAllChats',
  'getMessagesByChannelId',
  'sendMessage',
  'deleteChatById',
], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const prepareMessages: Ref<messagesFromChanelTypeFromBack[]> = ref([]);
const allChats: Ref<messagesFromChanelTypeFromBack[]> = ref([]);
const paginationKey = ref(0);
const router = useRouter();
const props = __props;

const emit = __emit;

// eslint-disable-next-line no-undef
const formData = _useModel<FormDataType>(__props, "modelValue");

const sortOptions: OptionType[] = [
  { id: 1, name: 'Все сообщения' },
  { id: 2, name: 'Непрочитанные' },
  { id: 3, name: 'Прочитанные' },
];

const sortOptionsId: Ref<1 | 2 | 3> = ref(1);
const currentChatId: Ref<number | undefined> = ref(undefined);
const deleteChatIdsLoading: Ref<number[]> = ref([]);
const chatIdsWithNewMessage = computed((): number[] => {
  return useChatStore().chatIdsWithNewMessage;
});
const sortChats = (optionId: 1 | 2 | 3) => {
  sortOptionsId.value = optionId;
  switch (optionId) {
    case 1:
      allChats.value = props.allMessages;
      break;
    case 2:
      allChats.value = props.allMessages.filter(el => !el.it_was_read);
      break;
    case 3:
      allChats.value = props.allMessages.filter(el => el.it_was_read);
      break;
  }
  prepareMessages.value = allChats.value;

  paginationKey.value++;
};

const updateChats = () => {
  if (allChats.value.length) {
    allChats.value = allChats.value.map(chat => {
      const foundChat = props.allMessages.find(el => el.id === chat.id);

      return foundChat ? foundChat : chat;
    });
  } else {
    sortChats(sortOptionsId.value);
  }
};

const showMessages = async (id: number) => {
  useChatStore().addOpenChatId(id);
  await router.push({
    query: {
      id: id,
    },
  });
  emit('getMessagesByChannelId', id);
};
const closeChat = (id: number) => {
  useChatStore().deleteOpenChatId(id);
};
const sendMessage = async (chatId: number) => {
  emit('sendMessage', chatId);
};

const deleteChat = async (chatId: number) => {
  deleteChatIdsLoading.value.push(chatId);
  try {
    await useChatStore().deleteChatById(chatId);
    emit('deleteChatById', chatId);
  } finally {
    const index = deleteChatIdsLoading.value.findIndex(el => el === chatId);

    if (index >= 0) {
      deleteChatIdsLoading.value.splice(index, 1);
    }
    sortChats(sortOptionsId.value);
  }
};

onMounted(() => {
  emit('showAllChats');

  const chatId = useRoute().query.id;

  if (chatId) {
    useChatStore().addOpenChatId(+chatId);
    emit('getMessagesByChannelId', chatId);
    currentChatId.value = +chatId;
  }
});

watch(
  () => props.allMessages,
  () => {
    updateChats();
  },
  { deep: true },
);

onUnmounted(() => {
  useChatStore().clearOpenChatId();
});

return (_ctx: any,_cache: any) => {
  const _component_base_select_input = _resolveComponent("base-select-input")!
  const _component_base_skeleton_loader = _resolveComponent("base-skeleton-loader")!
  const _component_base_image = _resolveComponent("base-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_base_popup = _resolveComponent("base-popup")!
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_textarea = _resolveComponent("base-textarea")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_expansion_panels = _resolveComponent("base-expansion-panels")!
  const _component_base_pagination_group = _resolveComponent("base-pagination-group")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(useAppStore)().getWindowWidth() <= 600 ? 'base-card' : 'div'), {
    class: "ads-items",
    "full-width-mobile": ""
  }, {
    default: _withCtx(() => [
      (_ctx.allMessages.length || _ctx.isShowAllMessagesLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_base_select_input, {
                loading: _ctx.isShowAllMessagesLoading,
                modelValue: sortOptionsId.value,
                options: sortOptions,
                arrow: "expand_more",
                height: "34",
                label: "Сортировка",
                "onUpdate:modelValue": sortChats
              }, null, 8, ["loading", "modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowAllMessagesLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(1, (i) => {
              return _createVNode(_component_base_skeleton_loader, {
                key: i,
                styles: { height: '94px', width: '100%' },
                class: "mb--5 mt--20",
                type: "mediumText"
              })
            }), 64))
          ]))
        : (prepareMessages.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prepareMessages.value, (message) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: message.id,
                  class: "mt--20"
                }, [
                  _createVNode(_component_base_expansion_panels, {
                    "is-open": currentChatId.value === message.id,
                    "is-full-collapse": "",
                    onOpenBlock: ($event: any) => (showMessages(message.id)),
                    onCloseBlock: ($event: any) => (closeChat(message.id))
                  }, {
                    title: _withCtx((titleProps) => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_router_link, {
                            to: {
                    name: 'offerCard',
                    params: { url: message.more.land.customUrl },
                  }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_base_image, {
                                src: message.type === 10 ? message.more.house.images[0] : undefined,
                                "border-radius": "",
                                cover: "",
                                height: "60",
                                name: "img",
                                version: "v10",
                                width: "96"
                              }, null, 8, ["src"])
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          _createElementVNode("div", _hoisted_7, [
                            (message.type === 10)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  (message.type === 10)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _hoisted_10,
                                        _createTextVNode(" " + _toDisplayString(message.more.house.address), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (
                      message.type === 11 && message.more.id !== _unref(useUserStore)().user?.id
                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createElementVNode("div", null, [
                                      _hoisted_12,
                                      _createTextVNode(" " + _toDisplayString(message.more.name), 1)
                                    ]),
                                    _createElementVNode("div", null, [
                                      _hoisted_13,
                                      _createTextVNode(" " + _toDisplayString(message.more.id), 1)
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16)),
                            _createElementVNode("div", null, [
                              (message.type === 10)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _hoisted_18,
                                    _createTextVNode(_toDisplayString((+message.more.house.price).toLocaleString()) + " ₽ ", 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (message.type === 10)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _hoisted_20,
                                    _createTextVNode(" " + _toDisplayString(message.more.house.id), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_21, _toDisplayString(new Date(message.last_message).toLocaleString()), 1)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              (message.removable)
                                ? (_openBlock(), _createBlock(_component_base_popup, {
                                    key: 0,
                                    "with-padding": ""
                                  }, {
                                    content: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("button", {
                                          disabled: deleteChatIdsLoading.value.find(el => el === message.id),
                                          onClick: ($event: any) => (deleteChat(message.id))
                                        }, [
                                          (deleteChatIdsLoading.value.find(el => el === message.id))
                                            ? (_openBlock(), _createBlock(_component_base_spinner, {
                                                key: 0,
                                                size: 20,
                                                color: "#009D3E"
                                              }))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_27, "Удалить"))
                                        ], 8, _hoisted_26)
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _hoisted_24
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (!message.it_was_read)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(message.unread_messages), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    content: _withCtx(() => [
                      _createVNode(_component_base_divider, { class: "ads-items__without-padding" }),
                      (_ctx.loadingChatIds.includes(message.id))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createVNode(_component_base_spinner, {
                              size: 50,
                              color: "#009D3E"
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            (_ctx.chatInfo[message.id]?.messages)
                              ? (_openBlock(), _createBlock(_unref(ChatComponent), {
                                  key: 0,
                                  messages: _ctx.chatInfo[message.id]?.messages,
                                  class: "ads-items__item ads-items__chat"
                                }, null, 8, ["messages"]))
                              : _createCommentVNode("", true),
                            (formData.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _createVNode(_component_base_textarea, {
                                    modelValue: formData.value.messages[message.id],
                                    "onUpdate:modelValue": ($event: any) => ((formData.value.messages[message.id]) = $event),
                                    styleType: 'light',
                                    height: "100",
                                    label: "Сообщение",
                                    withScroll: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                  _createElementVNode("button", {
                                    disabled: _ctx.sendMessageChatsLoading.includes(message.id),
                                    onClick: ($event: any) => (sendMessage(message.id))
                                  }, [
                                    _createVNode(_component_base_icon, {
                                      color: "#009D3E",
                                      "font-size": "30",
                                      name: "send"
                                    })
                                  ], 8, _hoisted_32)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _: 2
                  }, 1032, ["is-open", "onOpenBlock", "onCloseBlock"])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35)),
      (allChats.value.length || _ctx.isShowAllMessagesLoading)
        ? (_openBlock(), _createBlock(_component_base_pagination_group, {
            key: paginationKey.value,
            modelValue: prepareMessages.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((prepareMessages).value = $event)),
            class: _normalizeClass({ 'mt--30': _unref(useAppStore)().getWindowWidth() > 600 }),
            "is-loading": _ctx.isShowAllMessagesLoading,
            "show-btn": false,
            values: allChats.value,
            "auto-add-mobile": ""
          }, null, 8, ["modelValue", "class", "is-loading", "values"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})